<template>
  <div class="card-random block-card card-border ">
    <v-expansion-panel 
      :value="panel" 
      expand>
      <v-expansion-panel-content :lazy="lazyRendering">
        <template v-slot:header >
          <div class="block-card-title handle" >
            <div class="title-icon">
              <span class="botter-shuffle-icon white--text text-lg-2" />
            </div>
            <h4>
              Random Number 
              <v-icon 
                v-if = "errorsCount && errorsCount.errorsCount" 
                color = "error" 
                style = "margin-left: 4px;">error</v-icon>
              <span class="text--error" v-if="!validData">(Invalid Card Data)</span>
            </h4>
          </div>
        </template>
        <form-validation v-model = "errorsCount" v-if="validData">
          <div class="block-card-body">

            <v-layout 
              row 
              wrap>
              <v-flex xs6>
                <label>Minimum number</label>
                <v-text-field
                  v-model="data.from"
                  :error="!data.from"
                  :error-messages="!data.from? 'Minimum number is Required':''"
                  outline
                  type="number"
                />
              </v-flex>
              <v-flex xs6>
                <label for="">Maximum number</label>
                <v-text-field
                  v-model="data.to"
                  :error="!data.to"
                  :error-messages="!data.to? 'Maximum number is Required':''"
                  outline
                  type="number"
                />
              </v-flex>
              <v-flex xs12>
                <label for="">User parameters for the generated number </label>
                <vTextareaAutocomplete 
                  v-model="data.userAttribute" 
                  :type="'textfield'"
                  :validation-rules="autocompleteRandomValidationRules"/>
              </v-flex>

            </v-layout>
          </div>
        </form-validation>
        <slot name = "tail" />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import common from '../../../../utils/common'
import FormValidation from '../FormValidation'
export default {
  name: 'CardRandom',
  components: {
    FormValidation
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    index: {
      type: Number,
      default: () => {
        return 0
      }
    },
    blocksList: {
      type: Array,
      default: () => {
        return []
      }
    },
    validData: {
      type: Boolean,
      default: ()=> {
        return false
      }
    }
  },
  data() {
    return {
      errorsCount: { errorsCount: 0 },
      lazyRendering: true,
      valid: true,
      panel: 1,
      common,
      autocompleteRandomValidationRules: [
        v => !!v || 'User Attribute is Required'
      ]
    }
  },
  computed: {},
  watch: {
    errorsCount(val) {
      this.$emit('input', { errorsCount: val.errorsCount })
      this.data.errorsCount = val.errorsCount
    }
  },
  mounted() {
    if (this.data.errorsCount !== undefined) {
      this.errorsCount = this.data.errorsCount
    } else {
      // disabling Lazy rendering so we can grip errors count
      this.lazyRendering = false
      setTimeout(() => {
        // then we turn it on again to keep the performance up
        this.lazyRendering = true
      }, 1000)
    }
  },
  methods: {}
}
</script>

<style scoped>
</style>
